import axios from 'axios';
import config from '../config';

export default function (formData, uploadConfig = {}) {
  Object.assign(uploadConfig, { withCredentials: true });
  return axios.post(`${config.FILE_UPLOAD_HOST}/upload/file`, formData, uploadConfig)
    .then(response => response.data);
}

export const FileMapper = {
  image: 'PHOTO',
  video: 'VIDEO',
  audio: 'AUDIO',
  application: 'FILE',
};

export function getFileType(fileType) {
  const type = fileType.substring(0, fileType.indexOf('/'));
  if (Object.keys(FileMapper).includes(type)) {
    return FileMapper[type];
  }
  return FileMapper.application;
}



// WEBPACK FOOTER //
// ./src/utils/FileService.js